import React, { useState } from 'react';

const field = { width: '100%', boxSizing: 'border-box', padding: '10px 12px', borderRadius: '8px', border: '1px solid #cfd8e3', fontSize: '0.9rem', marginTop: '8px', fontFamily: 'inherit', color: '#1e3a5f', background: '#fff' };

const HandoffCard = ({ theme }) => {
  const esc = theme.escalation;
  const [open, setOpen] = useState(false);
  const [sent, setSent] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [needGuardian, setNeedGuardian] = useState(false);
  const [consentChecked, setConsentChecked] = useState(false);
  const [form, setForm] = useState({ contact_method: 'call', contact_value: '', best_time: '', note: '', guardian_name: '', guardian_phone: '' });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async () => {
    setError('');
    if (form.contact_value.trim().length < 5) { setError('Please tell us how the chaplain can reach you.'); return; }
    setBusy(true);
    try {
      const res = await fetch(`${window.location.origin}/api/v1/handoff-request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token') || ''}` },
        body: JSON.stringify({ partner: theme.id, ...form })
      });
      const data = await res.json().catch(() => ({}));
      if (res.ok) { setSent({ notified: !!data.notified }); return; }
      const detail = data.detail;
      if (detail && detail.error === 'guardian_required') setNeedGuardian(true);
      if (res.status === 401) setError('Please sign in to request a call.');
      else setError((detail && detail.message) || (typeof detail === 'string' ? detail : '') || 'Something went wrong. Please try again.');
    } catch (e) {
      setError('Could not reach the server. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  const box = { background: '#ffffff', border: '1.5px solid ' + theme.colors.accent, borderRadius: '16px', padding: '16px 18px', margin: '4px 0 16px', boxShadow: '0 4px 14px rgba(232,163,61,0.18)' };
  const btn = { marginTop: '12px', width: '100%', padding: '12px', borderRadius: '10px', border: 'none', cursor: 'pointer', background: theme.colors.primary, color: '#fff', fontSize: '0.95rem', fontWeight: 800 };
  const notice = { marginTop: '12px', padding: '12px', borderRadius: '10px', background: '#f4f7fb', color: theme.colors.primary, fontSize: '0.85rem', fontWeight: 700, textAlign: 'center', lineHeight: 1.45 };

  return (
    <div style={box}>
      <div style={{ fontSize: '0.95rem', fontWeight: 800, color: theme.colors.primary }}>{esc.title}</div>
      <div style={{ fontSize: '0.85rem', color: '#5b7392', marginTop: '5px', lineHeight: 1.45 }}>{esc.body}</div>

      {!esc.live ? (
        <>
          {open ? (
            <div style={notice}>In pilot, this connects you to your assigned Chaplain Care Team.</div>
          ) : (
            <button type="button" onClick={() => setOpen(true)} style={btn}>{esc.button}</button>
          )}
          <label style={{ display: 'flex', gap: '9px', alignItems: 'flex-start', marginTop: '11px', cursor: 'pointer' }}>
            <input type="checkbox" checked={consentChecked} onChange={(e) => setConsentChecked(e.target.checked)}
              style={{ marginTop: '2px', width: '15px', height: '15px', accentColor: theme.colors.primary, flexShrink: 0 }} />
            <span style={{ fontSize: '0.78rem', color: '#5b7392', lineHeight: 1.4 }}>{esc.consentLabel}</span>
          </label>
        </>
      ) : sent ? (
        <div style={notice}>
          {sent.notified ? 'Your request has been sent to a chaplain.' : 'Your request is saved, but we could not alert the chaplain automatically, so it may take longer.'}
          {' '}This is not an emergency line. If you are in danger or thinking about harming yourself, call or text 988 now.
        </div>
      ) : !open ? (
        <button type="button" onClick={() => setOpen(true)} style={btn}>{esc.button}</button>
      ) : (
        <div>
          <select value={form.contact_method} onChange={set('contact_method')} style={field}>
            <option value="call">Phone call</option>
            <option value="text">Text message</option>
            <option value="email">Email</option>
          </select>
          <input type="text" value={form.contact_value} onChange={set('contact_value')}
            placeholder={form.contact_method === 'email' ? 'Your email address' : 'Your phone number'} style={field} />
          <input type="text" value={form.best_time} onChange={set('best_time')} placeholder="Best time to reach you (optional)" style={field} />
          <textarea value={form.note} onChange={set('note')} rows={3} maxLength={600}
            placeholder="Anything you want the chaplain to know? (optional, sent to the chaplain)" style={{ ...field, resize: 'vertical' }} />
          {needGuardian && (
            <>
              <input type="text" value={form.guardian_name} onChange={set('guardian_name')} placeholder="Parent or guardian name" style={field} />
              <input type="text" value={form.guardian_phone} onChange={set('guardian_phone')} placeholder="Parent or guardian phone number" style={field} />
            </>
          )}
          {error && <div style={{ marginTop: '8px', color: '#991b1b', fontSize: '0.82rem', lineHeight: 1.4 }}>{error}</div>}
          <button type="button" onClick={submit} disabled={busy} style={{ ...btn, opacity: busy ? 0.6 : 1 }}>{busy ? 'Sending...' : 'Send request'}</button>
          <div style={{ fontSize: '0.75rem', color: '#5b7392', marginTop: '8px', lineHeight: 1.4 }}>Not an emergency line. If you are in danger, call 911, or call or text 988.</div>
        </div>
      )}
    </div>
  );
};

export default HandoffCard;
